import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import * as Icon from "react-feather";
import MatrixQuestionDescriptionDialog from "./MatrixQuestionDescriptionDialog";

const MatrixQuestionActions = ({
  Index,
  Question,
  handleRemove,
  handleChange,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    handleRemove(Index, false);
    handleClose();
  };

  const handleDescription = (description) => {
    handleChange(Index, description);
    handleClose();
  };

  return (
    <React.Fragment>
      <button
        aria-controls={"matQ" + Index}
        aria-haspopup="true"
        className="btn btn-transparent-dark btn-sm"
        onClick={handleClick}
      >
        <Icon.MoreVertical size={18} />
      </button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MatrixQuestionDescriptionDialog
          key={"matQDescr" + Index}
          Question_Text={Question.Question_Text}
          Description={Question.Description}
          handleMenuClose={handleClose}
          handleChange={handleDescription}
        />
        <MenuItem onClick={handleDelete}>Remove</MenuItem>
      </Menu>
    </React.Fragment>
  );
};

export default MatrixQuestionActions;
